/* DSL Quick-buy hover — toon quick-buy button on card hover */
(function(){
  if (!window.matchMedia("(hover: hover)").matches) return;
  document.addEventListener("mouseenter", function(e){
    if (!e.target.matches || !e.target.matches(".card-wrapper, .card")) return;
    if (e.target.querySelector(".dsl-quick-buy-hover")) return;
    var vid = e.target.querySelector("[data-variant-id]");
    if (!vid) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "dsl-quick-buy-hover";
    btn.dataset.quickAdd = vid.dataset.variantId;
    btn.textContent = "Quick-add";
    e.target.appendChild(btn);
  }, true);
})();